import { render, staticRenderFns } from "./ProblematicKits.vue?vue&type=template&id=3bfb7774&scoped=true&"
import script from "./ProblematicKits.vue?vue&type=script&lang=js&"
export * from "./ProblematicKits.vue?vue&type=script&lang=js&"
import style0 from "./ProblematicKits.vue?vue&type=style&index=0&id=3bfb7774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb7774",
  null
  
)

export default component.exports